import { ChainId } from './internal'

/**
 * DEX v2 SDK
 */
export const MULTICALL_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0xb465Fd2d9C71d5D6e6c069aaC9b4E21c69aAA78f',
  [ChainId.AVALANCHE]: '',
  [ChainId.FANTOM_TESTNET] : '0xcA11bde05977b3631167028862bE2a173976CA11', // multicall3
  [ChainId.FANTOM] : '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.OPTIMISM_GOERLI] : '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.OPTIMISM] : '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.EOS] : '0xFB7D8d8eDE596DdaFA7521a419Dbbb17a5be7c00',
  [ChainId.POLYGON_ZKEVM_TESTNET] : '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.POLYGON_ZKEVM] : '0xcA11bde05977b3631167028862bE2a173976CA11',
  [ChainId.ARBITRUM_ONE] : '0xcA11bde05977b3631167028862bE2a173976CA11'
}

export const LB_QUOTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0x2644fE413b8Fe94D69c4706455108368fa36354F',
  [ChainId.AVALANCHE]: '0x51409fD32C15E9857eeF9F28275FA0842C3C4545',
  [ChainId.FANTOM_TESTNET] : '0x870e7D38C15F5a215407C54554C12247a081c4De',
  [ChainId.FANTOM] : '0x9fbDf5e760394964F8C71fFF4Ff5CeA5B325237c',
  [ChainId.OPTIMISM_GOERLI] : '0xe3B015e2f379019d42eD7427825acaa0a0475742',
  [ChainId.OPTIMISM] : '0x5d659BDC0Fef665CBB838ca4C77B7a756746B4E8',
  [ChainId.EOS]: '',
  [ChainId.POLYGON_ZKEVM_TESTNET] : '',
  [ChainId.POLYGON_ZKEVM] : '',
  [ChainId.ARBITRUM_ONE] : ''
}
export const LB_QUOTER_V21_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FANTOM_TESTNET] : '0x8AFFfAc86DeB6069658Af9d5743403c882DD4d62',
  [ChainId.FANTOM] : '0xA1C5508C336Aa2BBC936e1B86a9bE46331e2c1CC',
  [ChainId.OPTIMISM_GOERLI] : '0xB675341Af0BB222C552F09c877713d3FcC9b8673',
  [ChainId.OPTIMISM] : '0x97e792198443482385c3BD7Eb16d11D0462ec10b',
  [ChainId.EOS]: '0xDcB25D45cc68dc15eEb42549Ee89104afeF861af',
  [ChainId.POLYGON_ZKEVM_TESTNET] : '0xc049842edCbEE1a2Cc7B55C60253FA7fc086fbB2',
  [ChainId.POLYGON_ZKEVM] : '0xe3B015e2f379019d42eD7427825acaa0a0475742',
  [ChainId.ARBITRUM_ONE] : '0x0E221e65F85336dB137b22596c5C5c259A629D15'
}

export const LB_ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0x7b50046cEC8252ca835b148b1eDD997319120a12',
  [ChainId.AVALANCHE]: '0xE3Ffc583dC176575eEA7FD9dF2A7c65F7E23f4C3',
  [ChainId.FANTOM_TESTNET] : '0x9Db9bE677602170e549100BB68a08aa66c3ab9E4',
  [ChainId.FANTOM] : '0xFC33f3cac9f6d1713a4B7787dF6a9a33bAD244d6',
  [ChainId.OPTIMISM_GOERLI] : '0x0E221e65F85336dB137b22596c5C5c259A629D15',
  [ChainId.OPTIMISM] : '',
  [ChainId.EOS]: '',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '',
  [ChainId.POLYGON_ZKEVM] : '',
  [ChainId.ARBITRUM_ONE] : ''
}

export const LB_ROUTER_V21_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FANTOM_TESTNET] : '0x945246659c51f6700333233f4A71E03c47c2EF55',
  [ChainId.FANTOM] : '0x795bF60522F36244E4e51ed5522fE83Df4D3Bf9a',
  [ChainId.OPTIMISM_GOERLI] : '0xf2249e497786bf256D7Aef70bb7f74c89860C354',
  [ChainId.OPTIMISM] : '0x408ba8dea8b514cc24F81e72795FC3DdbcA8Dbb5',
  [ChainId.EOS] : '0x873Aa6beD68d59dD6202DbB176Efc21e91c346b5',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '0x3845c8ae2C90dfe6Af1Bf1225b78e98043Af07F2',
  [ChainId.POLYGON_ZKEVM] : '0x0E221e65F85336dB137b22596c5C5c259A629D15',
  [ChainId.ARBITRUM_ONE] : '0x25b320A7C69e66515D7f6C044eC9AF49Fa1588BB'
}


export const LB_FACTORY_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0x6B8E020098cd1B3Ec9f811024bc24e51C660F768',
  [ChainId.AVALANCHE]: '0x6E77932A92582f504FF6c4BdbCef7Da6c198aEEf',
  [ChainId.FANTOM_TESTNET] : '0xc7390F32B36036D1D82B4C0DeF3742123db478Ee',
  [ChainId.FANTOM] : '0xdD693b9F810D0AEE1b3B74C50D3c363cE45CEC0C',
  [ChainId.OPTIMISM_GOERLI] : '0x5A5c0C4832828FF878CE3ab4fEc44d21200b1496',
  [ChainId.OPTIMISM] : '0x5B87083EE483728DfFF218a5538104050268Ec43',
  [ChainId.EOS] : '',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '',
  [ChainId.POLYGON_ZKEVM] : '',
  [ChainId.ARBITRUM_ONE] : ''
}

export const LB_FACTORY_V21_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '',
  [ChainId.AVALANCHE]: '',
  [ChainId.FANTOM_TESTNET] : '0x4dFdB3CcC8c6c6B488b9994ab4744d05B854A857',
  [ChainId.FANTOM] : '0x640801a6983c109805E928dc7d9794080C21C88E',
  [ChainId.OPTIMISM_GOERLI] : '0x60F9eB70E54d488ea62541Fd94c4ec1A6d70E615',
  [ChainId.OPTIMISM] : '0xd08C98F6409fCAe3E61f3157B4147B6595E60cf3',
  [ChainId.EOS] : '0x24b972796274D255b84c2B36e8a29bdAAdb65206',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '0x5d659BDC0Fef665CBB838ca4C77B7a756746B4E8',
  [ChainId.POLYGON_ZKEVM] : '0x5A5c0C4832828FF878CE3ab4fEc44d21200b1496',
  [ChainId.ARBITRUM_ONE] : '0xEE0616a2DEAa5331e2047Bc61E0b588195A49cEa'
}


export const DEXLENS_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0x8b9e4f329f013320670459Bcab01C2b8DC9C32c3',
  [ChainId.AVALANCHE]: '0x16978e42a9b14A19878161A7EdE255637ce361e0',
  [ChainId.FANTOM_TESTNET] : '0xe81ea8e2C236aC7149bEB1Ba69f21c52fA11a1F8',
  [ChainId.FANTOM] : '0xa207f6C68aD712B60223654547D2805005Ca716E',
  [ChainId.OPTIMISM_GOERLI] : '0x97e792198443482385c3BD7Eb16d11D0462ec10b',
  [ChainId.OPTIMISM] : '0x56018054BEaC139D6B9cEf9973963DEE7Ed217c3',
  [ChainId.EOS] : '',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '0xf450dE087DdfBEf293699099934713802B57C1F1',
  [ChainId.POLYGON_ZKEVM] : '0xb2755FeEc193a718f6135351057a63b2F7B95cef',
  [ChainId.ARBITRUM_ONE] : '0xa0229891BaC4777656f77Ca761E1fac8B9Cf8283'
}





